import React, { useEffect, useRef } from "react";
import Hls from "hls.js";
import styles from "./AzureMediaPlayer.module.css";

export default function VideoPlayer({ src, options = {} }) {
  const videoRef = useRef(null);
  const hlsRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !src || !src[0]) return;

    const { src: url, type, sasToken } = src[0];
    if (!url) return;

    const isHls = url.includes(".m3u8");

    if (hlsRef.current) {
      hlsRef.current.destroy();
      hlsRef.current = null;
    }

    if (isHls && Hls.isSupported()) {
      const hlsConfig = sasToken
        ? {
            xhrSetup: (xhr, reqUrl) => {
              if (!reqUrl.includes("?")) reqUrl += sasToken;
              else if (!reqUrl.includes("sig="))
                reqUrl += "&" + sasToken.substring(1);
              xhr.open("GET", reqUrl, true);
            }
          }
        : {};
      const hls = new Hls(hlsConfig);
      hlsRef.current = hls;
      hls.loadSource(url);
      hls.attachMedia(video);
      if (options.autoplay) {
        hls.on(Hls.Events.MANIFEST_PARSED, () => video.play().catch(() => {}));
      }
    } else {
      // Use a <source> element with type hint for iOS Safari native HLS and MP4
      while (video.firstChild) video.removeChild(video.firstChild);
      const sourceEl = document.createElement("source");
      sourceEl.src = url;
      if (type) sourceEl.type = type;
      video.appendChild(sourceEl);
      video.load();
      if (options.autoplay) video.play().catch(() => {});
    }

    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
        hlsRef.current = null;
      }
      while (video.firstChild) video.removeChild(video.firstChild);
    };
  }, [src, options.autoplay]);

  return (
    <div
      style={{ paddingBottom: "56.25%" }}
      className={styles.azure_mp_container}
    >
      <video ref={videoRef} controls className={styles.video} />
    </div>
  );
}
